import { Avatar, Button, Loading } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { tGetMetaPagesData } from '../../../../../../../providers/IntegrationsProvider/Integrations.types.ts';
import { useMetaConnectionModalContext } from '../../MetaConnectionModal.hook.ts';
import useMetaPage from './MetaPage.hook.ts';
import './MetaPage.styles.scss';
import { useAnalytics } from 'src/hooks/analytics/useAnalytics.hook';

export default function MetaPage(props: tGetMetaPagesData) {
  const { loading, connected } = useMetaConnectionModalContext();
  const { connectionCompleted, selectPage, processing } = useMetaPage();
  const { t } = useTranslation('dashboard/dashboard');
  const { trackEvent } = useAnalytics();

  return (
    <div className="MetaPage">
      <Avatar
        shape="circle"
        letters={props.name}
        size="xs"
        src={props.image}
        className="MetaPage__Left"
      />
      <div className="MetaPage__Center">
        <div className="MetaPage__Center__Name">{props.name}</div>
        <div className="MetaPage__Center__Data">({props.page_id})</div>
      </div>

      <Button
        onClick={
          connectionCompleted
            ? () => {}
            : () => {
                selectPage(props);
                trackEvent(
                  'front.dashboard.integrations.meta.connect_btn.success',
                  {
                    displayName: 'Conexión exitosa meta',
                    description:
                      'Cuántas usuarias se conectaron exitosamente a meta',
                    accountType: 'meta',
                    accountStatus: 'connected',
                  },
                );
              }
        }
        disabled={loading || (!connectionCompleted && connected)}
        className="MetaPage__Button text-base-100 text-xs"
        size="sm"
        color={connectionCompleted ? 'success' : 'primary'}
      >
        {processing ? (
          <Loading size="sm" />
        ) : (
          t('components.modals.MetaConnection.connectButton')
        )}
      </Button>
    </div>
  );
}
